<template>
  <div class="table-box">
    <!--表格-->
    <el-table
      class="list"
      v-loading="loading"
      header-row-class-name="table-header"
      :highlight-current-row="tableOptions.isRowClick?true:false"
      :max-height="tableOptions.height?tableOptions.height:maxHeight"
      :ref="tableOptions.tableName||tableDefault.tableName"
      :data="tableData"
      :border="tableOptions.border||tableDefault.border"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @expand-change="expandChange"
      :expand-row-keys="expandKeys"
      row-key="id"
      :show-summary="tableOptions.showSummary"
      :summary-method="(tableOptions.summaryColumns && tableOptions.summaryColumns.length>0)
      ?(tableOptions.summaryMethod||tableDefault.summaryMethod):undefined"
      :header-cell-style="handleHeaderCellClass"
      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column
        type="expand"
        v-if="tableOptions.isExpand||tableDefault.isExpand"
      >
        <template slot-scope="scope">
          <el-table
            :data="scope.row.children"
            class="list"
            v-loading="loading"
            :ref="tableOptions.expandTableOptions.tableName"
            :fixed="tableOptions.expandTableOptions.fixed"
          >
            <el-table-column
              show-overflow-tooltip
              v-for="(column,index) in tableOptions.expandTableOptions.columns"
              :key="index"
              :class-name="column.class"
              :property="column.prop"
              :label="column.label"
              :align="column.align"
              :min-width="column.width"
            >
              <template slot-scope="scope">
                <el-link
                  v-if="column.showDetail"
                  :underline="false"
                  type="primary"
                  @click="linkToDetail(scope.row)"
                >{{ scope.row[column.prop] }}
                </el-link>
                <span
                  v-else-if="column.merge"
                  v-for="(p,index) in column.prop.split(',')"
                  :key="index"
                >{{ scope.row[p] }}&nbsp;</span>
                <img
                  class="table-img"
                  :title="scope.row[column.prop]"
                  :class="{'cursor':column.click}"
                  v-else-if="column.type === 'image'"
                  @click="btnCommon(column, scope.row)"
                  :src="column.defaultValue ? column.defaultValue : scope.row[column.prop]"
                />
                <div
                  v-else-if="column.enumData"
                  v-html="$utils.getEnumItem(column,scope.row[column.prop])"
                ></div>
                <span v-else>{{ scope.row[column.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              v-if="tableOptions.expandTableOptions.operation && tableOptions.expandTableOptions.operation.length>0"
              class="tolcof"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-for="btn in tableOptions.expandTableOptions.operation"
                  :key="btn.text"
                  @click="btnCommon(btn, scope.row)"
                >{{ btn.text }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <!--多选-->
      <el-table-column
        v-if="tableOptions.showSelect"
        type="selection"
        width="45"
        :selectable="selectEnable"
      ></el-table-column>
      <!--索引-->
      <!--      <el-table-column-->
      <!--        align="center"-->
      <!--        v-if="tableOptions.indexShow||tableDefault.indexShow"-->
      <!--        type="index"-->
      <!--        width="60"-->
      <!--        label="序号"-->
      <!--        :index="tableOptions.indexMethod||tableDefault.indexMethod"-->
      <!--      ></el-table-column>-->
      <el-table-column
        align="center"
        v-if="tableOptions.indexShow||tableDefault.indexShow"
        :width="tableOptions.clearSortable?80:60"
        label="序号"
      >
        <template slot-scope="scope" slot="header">
          <span>序号</span>
          <el-tooltip :aa="scope" class="item" effect="dark" content="恢复默认排序" placement="top-start">
            <i v-if="tableOptions.clearSortable"
               class='el-icon-refresh-right'
               style="color:#409eff; margin-left:5px;cursor: pointer;"
               @click="clearSort"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <template v-for="(column,index) in tableOptions.columns">
        <el-table-column
          :key="index"
          v-if="column.hidden == true?false:true"
          :class-name="column.class"
          :property="column.prop"
          :label="column.label"
          :align="column.align ||tableOptions.align"
          :min-width="column.width || tableOptions.align"
          :sortable="column.sortable||tableOptions.sortable||false"
          :show-overflow-tooltip="column.type !== 'image'"
        >

          <template slot-scope="scope">
            <div
              :style="{height:rowHeight+'px',lineHeight:rowHeight+'px'}"
              v-if="dataNotNull(scope.row[column.prop]) || column.merge"
            >
              <el-link
                v-if="column.showDetail"
                type="primary"
                @click="linkToDetail(scope.row)"
              >{{ scope.row[column.prop] }}
              </el-link>
              <span
                v-else-if="column.merge"
                v-for="(p,index) in column.prop.split(',')"
                :key="index"
              >{{ scope.row[p] }}&nbsp;</span>
              <progress-bar
                v-else-if="column.type === 'progress'"
                :column='column'
                :row="scope.row"
              ></progress-bar>
              <template v-else-if="column.type === 'image'">
                <!--                <img-->
                <!--                  class="table-img"-->
                <!--                  :title="scope.row[column.prop]"-->
                <!--                  :class="{'cursor':column.click}"-->
                <!--                  v-show="column.defaultValue||dataNotNull(scope.row[column.prop])"-->
                <!--                  @click="btnCommon(column, scope.row)"-->
                <!--                  :src="column.defaultValue||scope.row[column.prop]"-->
                <!--                />-->
                <el-popover
                  placement="right"
                  trigger="hover"
                >
                  <img
                    :src="column.defaultValue ? column.defaultValue : scope.row[column.prop]"
                    style="height: 200px;"
                  />
                  <img
                    v-if="column.defaultValue||imgNotNull(scope.row[column.prop])"
                    slot="reference"
                    :src="column.defaultValue ? column.defaultValue : scope.row[column.prop]"
                    class="table-img"
                    style="cursor: pointer"
                  />
                </el-popover>
              </template>
              <span v-else-if="column.asyncDeal">{{ scope.row[column.prop + 'async'] }}</span>
              <div
                v-else-if="column.enumData"
                v-html="getEnumItem(column,scope.row[column.prop])"
              ></div>
              <!--是/否-->
              <div
                v-else-if="column.selfData"
                v-html="getSelfItem(column,scope.row[column.prop])"
              ></div>

              <span
                v-else-if="column.deal"
                v-html="column.deal(scope.row,column)"
                @click="itemClick(column,scope.row)"
              ></span>
              <div
                @click="itemClick(column,scope.row)"
                v-else-if="column.callback && imgNotNull(scope.row[column.prop])"
                class="td-click"
                :title="column.title"
              >
                <el-link type="primary">{{ scope.row[column.prop] }}</el-link>
              </div>
              <div v-else-if="column.type === 'switch'">
                <el-switch
                  v-model="scope.row[column.prop]"
                  :active-value="column.activeValue"
                  :inactive-value="column.inactiveValue"
                  :active-text="column.activeText"
                  :inactive-text="column.inactiveText"
                  @change="switchChange(scope.row,column)"
                ></el-switch>
              </div>
              <span v-else>{{ scope.row[column.prop] }}</span>
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="toolConfig.length>0"
        label="操作"
        :fixed="tableData.length>0?'right':false"
        align="center"
        :width="tableOperateWidth"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-for="btn in toolConfig"
            v-show="btn.filter?btn.filter(scope.row):true"
            :key="btn.name||btn.label"
            @click="btnCommon(btn, scope.row)"
          >{{ btn.name || btn.label }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ page.total }}条</div>
      <!--分页-->
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.pageSize"
        :page-sizes="tableOptions.pageList || [10, 15, 20, 30, 40,100,200]"
        :layout="tableOptions.layout || 'sizes, prev, pager, next, jumper'"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import progressBar from "../controls/progressBar";
import detail from "./detail";
import table from "@/mixin/table.js";

export default {
  name: "tableTemplate",
  mixins: [table],
  components: {progressBar},
  props: {
    detailColumns: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 操作按钮
    toolConfig: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableOptions: {
      type: Object,
      default: () => {
        return {
          paginationSize: null, //个别表格有灵活展示需求
          tableName: "table",
          stripe: false, //是否斑马纹
          border: false, //是否带边框
          fixed: false, //string, boolean  true, left, right true 表示固定在左侧 表格左侧或右侧一列固定
          showSelect: false, // 是否显示选择框
          template: "", //自定义列模板 传入模板名称
          indexShow: false, //是否显示索引
          indexMethod: this.getIndex,
          showSummary: false,
          summaryMethod: () => {
          },
          columns: [
            {label: "ID", prop: "id", width: "100"},
            {label: "名称", prop: "name", width: "100"},
          ],
          url: "",
          param: {},
        };
      },
    },
  },
  data() {
    return {
      tableData: [], // 表格数据
      page: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      selectRow: [],
      loading: false,
      expandData: [],
      expandKeys: [],
      searchAfterBtn: [], //搜索栏按钮
      tableOperateWidth: 0, //操作栏宽度
      rowHeight: "",
      maxHeight: "100%",
      searchParam: {},
      moreShow: true,
      sumEntity: {},
      orderArray: [],
      sortField: {},
      descArr: [],
      ascArr: [],
      sortFlag: false,
    };
  },
  created() {
    this.page.pageSize =
      this.tableOptions.paginationSize || this.$utils.getDataByKey(this.$utils.localStorageKeys.pageSize) || 10;
    this.toolConfig.map((item) => {
      if (this.toolConfig.length == 1) {
        this.tableOperateWidth = 80
      }
      if (this.toolConfig.length > 1) {
        this.tableOperateWidth += (item.name || item.label).length * 14 + 20;
      }
    });
    // this.toolConfig.map((item) => {
    //   if (item.more) {
    //     this.tableOperateWidth += (item.name || item.label).length * 25 + 20;
    //   }
    // });
    // if (this.toolConfig.length > 2) {
    //   this.tableOperateWidth += 65;
    // }

    // this.getTableData();
  },
  watch: {
    // 默认选中table的第一行，将其高亮显示
    tableData: function () {
      let refName = this.tableOptions.tableName || this.tableDefault.tableName
      if (this.tableData.length > 0 && this.tableOptions.isRowClick) {
        // this.$refs[refName].setCurrentRow(this.tableData[0])
        this.$emit('rowClick', this.tableData[0], refName)
      }
    }
  },
  mounted() {
    this.setTableTrHeight();//列表行高 表头高度固定
    // 默认选中 单击第一列
    // if(this.tableOptions.isRowClick && this.tableData.length>0){
    //   this.rowClick(this.tableData[0])
    // }
  },
  methods: {
    // 单击某行
    rowClick(row, column) {
      let refName = this.tableOptions.tableName || this.tableDefault.tableName
      if (this.tableOptions.isRowClick || this.tableOptions.oneClick) {
        this.$emit('rowClick', row, refName)
      }
    },
    setCurrentRow(refName, row) {
      if (row) {
        this.$refs[refName].setCurrentRow(row)
      } else {
        this.$refs[refName].setCurrentRow()
      }
    },
    clearSort() {
      this.descArr = []
      this.ascArr = []
      this.sortField = {}
      this.tableOptions.param.ascColumn = null
      this.tableOptions.param.descColumn = null
      this.getTableData();
    },
    // 驼峰转换下划线
    toLine(name) {
      return name.replace(/([A-Z])/g, "_$1").toLowerCase();
    },
    //添加排序方法（可把多个字段共同加入排序）
    handleHeaderCellClass({row, column, rowIndex, columnIndex}) {
      if (this.sortField[column.property]) {
        column.order = this.sortField[column.property]
      } else {
        column.order = null
      }
    },
    // 点击排序箭头 多列排序
    sortChange(column) {
      let ascValue = ''
      let descValue = ''
      // 触发的排序和缓存的排序相同时，取消该字段的排序
      if (!column.order || this.sortField[column.prop] === column.order) {
        this.sortField[column.prop] = null
      } else {
        this.sortField[column.prop] = column.order
      }
      this.descArr = []
      this.ascArr = []
      for (const i in this.sortField) {
        if (this.sortField[i] === 'ascending') {
          this.ascArr.push({
            "prop": i,
            "order": this.sortField[i]
          })
        }
        if (this.sortField[i] === 'descending') {
          this.descArr.push({
            "prop": i,
            "order": this.sortField[i]
          })
        }
      }
      this.ascArr.forEach(v => {
        ascValue += this.toLine(v.prop) + ','
      })
      this.descArr.forEach(v => {
        descValue += this.toLine(v.prop) + ','
      })
      if (ascValue && ascValue.lastIndexOf(',') != -1) {
        ascValue = ascValue.substring(0, ascValue.lastIndexOf(','))
      }
      if (descValue && descValue.lastIndexOf(',') != -1) {
        descValue = descValue.substring(0, descValue.lastIndexOf(','))
      }
      this.tableOptions.param.ascColumn = ascValue
      this.tableOptions.param.descColumn = descValue
      this.getTableData();
    },
    // 单列排序
    // sortChange(column){
    //   let sortValue = this.toLine(column.prop)
    //   if(column.order){
    //     if(column.order === 'ascending'){//升序
    //       this.tableOptions.param.ascColumn = sortValue
    //       this.tableOptions.param.descColumn = null
    //     }else{//降序
    //       this.tableOptions.param.descColumn = sortValue
    //       this.tableOptions.param.ascColumn = null
    //     }
    //   }else{//默认
    //     this.tableOptions.param.descColumn = null
    //     this.tableOptions.param.ascColumn = null
    //   }
    //   this.getTableData();
    // },
    //多选禁用与否
    selectEnable(row, rowIndex) {
      if (this.tableOptions.selectEnable && row.reSelected) {
        return false;
      } else {
        return true;
      }
    },
    otherShow() {
      this.tableOperateWidth = 0;
      if (this.moreShow) {
        this.toolConfig.map((item) => {
          console.log(item.name.length)
          item.more = true;
          this.tableOperateWidth += (item.name || item.label).length * 25 + 20;
        });
        this.moreShow = false;
      } else {
        this.toolConfig.map((item) => {
          if (item.code === "update" || item.code === "delete") {
            item.more = true;
            this.tableOperateWidth += (item.name || item.label).length * 25 + 20;
          } else {
            item.more = false;
          }
        });
        this.tableOperateWidth += 65;
        this.moreShow = true;
      }
    },
    //展开项点击事件
    expandChange(row, expandedRows) {
      let isOpen = expandedRows.findIndex((item) => item.id === row.id);
      // 若是关闭，无需请求数据
      if (isOpen == -1) return;
      this.expandKeys = [row.id];
      this.$axios
        .fetchPost(this.tableOptions.expandTableOptions.url + "?id=" + row.id)
        .then((data) => {
          if (data.code == 200) {
            this.$nextTick(() => {
              this.$set(row, "children", data.data);
            });
          }
        });
    },

    //清除选中
    clearSelection() {
      this.$refs[this.tableOptions.tableName].clearSelection();
    },
    //添加详情路由
    addRouter() {
      let childrenRoute = this.$router.options.routes[0].children;
      let routerUrl = this.$route.path + "/detail";
      let currentRoute = childrenRoute.findIndex(
        (item) => item.path == this.$route.path
      )[0];
      if (
        childrenRoute.filter((item) => {
          return item.path == routerUrl;
        }).length == 0
      ) {
        let title = (currentRoute.meta && currentRoute.meta.title) || "";
        this.$router.options.routes[0].children.push({
          path: routerUrl,
          name: this.$route.name + "Detail",
          component: detail,
          meta: {
            requireAuth: true,
            title: title,
          },
        });
        this.$utils.setDataByKey(
          this.$utils.localStorageKeys.NEWESTROUTE,
          this.$router.options.routes
        );
        this.$router.addRoutes(this.$router.options.routes);
      }
    },
    //查看详情
    linkToDetail(data) {
      this.addRouter();
      this.$store.commit(this.$utils.storeKeys.FORMINFO, this.detailColumns);
      this.$router.push({
        path:
          `${this.$route.path}/detail?id=${data.id}&redirect=` +
          this.$route.path,
      });
    },
    //弹窗
    linkToDetailBox(data) {
      this.$emit("detailBox", data);
    },
    //选中项
    handleSelectionChange(val) {
      this.selectRow = val;
    },
    // 设置条数
    handleSizeChange(pageSize) {
      this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, pageSize);
      this.page.pageSize = pageSize;
      this.page.current = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(value) {
      this.page.current = value;
      this.getTableData();
    },
    //搜索清空
    clearSearch() {
      this.searchParam = {};
      this.getTableData();
    },
    //搜索
    searchSubmit(param) {
      this.page.current = 1;
      this.searchParam = param;
      this.getTableData();
    },
    //添加或修改成功
    operationSuccess() {
      this.page.current = 1;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      this.page.pageSize =
        this.tableOptions.paginationSize ||
        this.$utils.getDataByKey(this.$utils.localStorageKeys.pageSize) ||
        10;
      // 直播间所需参数
      if (this.tableOptions.liveSet && this.tableOptions.param) {
        if (this.tableOptions.param.limit) {
          this.tableOptions.param.limit = this.page.pageSize
        }
        if (this.tableOptions.param.start != undefined || this.tableOptions.param.start != null) {
          this.tableOptions.param.offset = (this.page.current - 1) * this.page.pageSize
        }
        if (this.tableOptions.param.start != undefined || this.tableOptions.param.start != null) {
          console.log(this.tableOptions.param)
          this.tableOptions.param.start = (this.page.current - 1) * this.page.pageSize
        }
        // console.log(this.tableOptions.param)
      }
      let searchParam = {
        pageNumber: this.page.current,
        pageSize: this.page.pageSize,
      };
      Object.assign(searchParam, this.tableOptions.param || {});
      Object.assign(searchParam, this.searchParam);
      if (this.tableOptions.url) {
        this.loading = true;
        this.$axios
          .fetchPost(this.tableOptions.url + "/page", searchParam)
          .then((data) => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              // data.data.room_info 直播间 data.data.goods 直播商品
              this.tableData = data.data.records || data.data.room_info || data.data.goods;
              this.page.total = data.data.total;
              // 空数据处理
              // if(this.tableData.length>0){
              //   this.tableData.forEach(v=>{s
              //     Object.keys(v).forEach((key)=>{
              //       if(v[key] === '' || v[key] === null || v[key] === undefined){
              //         v[key] = '--'
              //       }
              //     });
              //   })
              // }
              if (data.data.sumEntity) {
                this.sumEntity = data.data.sumEntity;
              }
            } else {
              this.$message({message: '请求列表失败：' + '[' + data.code + ']' + data.errorMsg, type: "error"});
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      }
    },
    getTableSelectRow() {
      return this.selectRow;
    },
  },
};
</script>
<style>
.table-box {
  position: relative;
  background-color: #fff;
  /*box-shadow: -3px -3px 5px rgba(69, 70, 72, 0.1),*/
  /*5px 3px 3px rgba(69, 70, 72, 0.1);*/
  border-radius: 5px;
  /*padding-bottom: 50px;*/
}

.table-box .status-item {
  /*width:64px;*/
  /*text-align: center;*/
  line-height: 28px;
  height: 28px;
  padding: 0 20px;
  display: inline-block;
  border: 0;
  border-radius: 4px;
  font-size: 12px;
}

.table-box .el-table {
  margin-bottom: 6px;
  overflow: auto;
}

.table-box .operate-btn {
  height: 20px;
  background-color: #fff;
  border: 0;
  color: #000;
  line-height: 20px;
  padding: 0 10px 0 10px;
  position: relative;
  font-size: 13px;
}

.table-box .operate-btn::before {
  font-weight: bolder;
  color: #409eff;
}

.table-box .total-cue {
  line-height: 30px;
  font-size: 12px;
  color: #46a0fc;
  margin-right: 10px;
}

.table-box .pagination-box {
  /*position: absolute;*/
  /*left: 0;*/
  /*bottom: 0px;*/
  width: 100%;
  padding: 0 20px;
  /*line-height: 37px;*/
}

.table-box .el-pagination__sizes .el-select,
.table-box .el-pagination__sizes .el-select .el-input {
  width: 100px;
}

.table-box .el-table--enable-row-transition .el-table__body td {
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.table-box .el-table--enable-row-transition .el-table__body td:nth-of-type(1) {
  border-left: 1px solid #f0f0f0;
}

.table-box .el-table th.is-leaf {
  border-bottom: 1px solid #f0f0f0;
}

.table-box .el-button.el-button--text:nth-of-type(2) {
  /*color: red;*/
}

.table-box .el-table .cell {
  overflow: hidden;
}

/*table滚动条加高*/
.table-box div::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  margin-top: 10px;
}

.el-table__fixed-right {
  height: auto !important;
  bottom: 10px !important;
}

.el-table__fixed-right::before, .el-table__fixed::before {
  height: 0;
}

.el-table__fixed-body-wrapper .el-table__body {
  padding-bottom: 10px;
}

/*固定列导致底部滚动条在固定列下方无法拉动*/
.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

/*表格高度错乱问题解决*/
.el-table td.is-hidden > * {
  visibility: visible !important;
}

/*!*table滚动条加高*!*/
/*.table-box div::-webkit-scrollbar{*/
/*  width:10px;*/
/*  height:10px;*/
/*  margin-top: 10px;*/
/*}*/
/*.el-table__fixed-right::before, .el-table__fixed::before{*/
/*  height:0;*/
/*}*/
/*.el-table__fixed-right {*/
/*  height: auto !important;*/
/*  !*bottom: 10px !important;*!*/
/*}*/
/*.el-table__fixed-body-wrapper .el-table__body{*/
/*  padding-bottom:10px;*/
/*}*/
/*!*固定列导致底部滚动条在固定列下方无法拉动*!*/
/*.el-table--scrollable-x .el-table__body-wrapper {*/
/*  z-index: 1;*/
/*}*/
/*!*表格高度错乱问题解决*!*/
/*.el-table td.is-hidden>* {*/
/*  visibility: visible !important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/template/tableTemplate.vue